module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('v-toolbar', [(_vm.showGoBackButton) ? _c('v-toolbar-side-icon', {
    staticClass: "toolbar-go-back"
  }, [_c('v-icon', {
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("arrow_back")])], 1) : _vm._e(), _vm._v(" "), _c('v-toolbar-title', {
    staticClass: "centered-text"
  }, [_vm._v("Ponce"), (!_vm.isOnline) ? _c('v-icon', {
    staticClass: "toolbar-offline-icon",
    attrs: {
      "color": "#F93A2F"
    }
  }, [_vm._v("cloud_off")]) : _vm._e()], 1), _vm._v(" "), (_vm.showSignUpSteps) ? _c('v-toolbar-items', {
    staticClass: "flex-none"
  }, [_c('b', {
    staticClass: "align-self-center"
  }, [_vm._v("Paso " + _vm._s(_vm.currentStep) + " de 2")])]) : _vm._e(), _vm._v(" "), (_vm.showOrganizationSteps) ? _c('v-toolbar-items', {
    staticClass: "flex-none"
  }, [_c('b', {
    staticClass: "align-self-center"
  }, [_vm._v("Paso 1 de 1")])]) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-17238c32","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shared/Toolbar.vue
// module id = 759
// module chunks = 12